import { createClient } from 'contentful';

import { config } from './config';

const isProduction = window.location.host.includes('my');

export const contentfulClient = createClient({
    space: config.contentful.spaceId,
    accessToken: isProduction
        ? config.contentful.accessToken
        : config.contentful.contentPreviewToken,
    host: process.env.REACT_APP_CONTENTFUL_URL,
});
